import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import './ForgotPassword.css';

const API_BASE_URL = process.env.REACT_APP_API_URL || '';

const ForgotPassword = () => {
  const [email, setEmail] = useState('');
  const [loading, setLoading] = useState(false);
  const [success, setSuccess] = useState(false);
  const [error, setError] = useState('');
  const navigate = useNavigate();

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setError('');
    setSuccess(false);

    try {
      const response = await fetch(`${API_BASE_URL}/api/auth/forgot-password`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({ email }),
      });

      const data = await response.json();

      if (response.ok && data.success) {
        setSuccess(true);
      } else {
        // Always show success message (security best practice - prevents email enumeration)
        setSuccess(true);
      }
    } catch (err) {
      // Even on error, show success message (security best practice)
      setSuccess(true);
      console.error('Error:', err);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="forgot-password-page">
      <div className="forgot-password-container">
        <button 
          className="back-button" 
          onClick={() => navigate('/')}
          aria-label="Back to login"
        >
          <span className="material-icons">arrow_back</span>
        </button>
        <div className="forgot-password-box">
          <div className="forgot-password-header">
            <h1 className="forgot-password-title">Reset Password</h1>
            <p className="forgot-password-subtitle">
              {success 
                ? "Check your email for password reset instructions"
                : "Enter your email address and we'll send you a link to reset your password"
              }
            </p>
          </div>

          {!success ? (
            <form onSubmit={handleSubmit} className="forgot-password-form">
              {error && (
                <div className="error-message">
                  <span className="material-icons">error</span>
                  {error}
                </div>
              )}
              
              <div className="input-group">
                <span className="material-icons">email</span>
                <input
                  type="email"
                  name="email"
                  placeholder="Email address"
                  value={email}
                  onChange={(e) => setEmail(e.target.value)}
                  required
                  autoFocus
                />
              </div>

              <button type="submit" className="btn-primary full-width" disabled={loading}>
                {loading ? 'Sending...' : 'Send Reset Link'}
              </button>

              <div className="forgot-password-footer">
                <a href="#" onClick={(e) => { e.preventDefault(); navigate('/'); }}>
                  <span className="material-icons">arrow_back</span>
                  Back to Login
                </a>
              </div>
            </form>
          ) : (
            <div className="success-message">
              <div className="success-icon">
                <span className="material-icons">check_circle</span>
              </div>
              <h2>Check Your Email</h2>
              <p>
                If an account exists for <strong>{email}</strong>, you'll receive a password reset link shortly.
              </p>
              <div className="success-actions">
                <button 
                  className="btn-primary full-width" 
                  onClick={() => navigate('/')}
                >
                  Back to Login
                </button>
                <p className="resend-link">
                  Didn't receive the email?{' '}
                  <a href="#" onClick={(e) => { e.preventDefault(); setSuccess(false); setEmail(''); }}>
                    Try again
                  </a>
                </p>
              </div>
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default ForgotPassword;

